import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/services/message.service';
import { UserModel } from 'src/app/services/users/models/user-model';
import { UsersService } from 'src/app/services/users/user.service';
import { EditbaseComponent } from '../../editbase.component';
import { SubmenuService } from '../../submenu/submenu.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less']
})
export class EditComponent extends EditbaseComponent implements OnInit {

  user:UserModel = new UserModel();
  activetab :string = "basic-info";

  constructor(private activatedRoute: ActivatedRoute, public usersService: UsersService, public messageService:MessageService, 
    public submenuService:SubmenuService, public translate: TranslateService) 
  { 
    super()

  }

  ngOnInit(): void {
     
    let userId = this.activatedRoute.snapshot.params.userId;

    if(userId>0)
    {
      this.messageService.showLoading();
      this.usersService.loadById(userId).subscribe((data:UserModel) => {
        this.user = data;
        this.messageService.hideLoading();
      });
    }
  }


  setActiveTab(tabName:string){
    this.activetab  = tabName;
  }
  
  ngAfterViewChecked(){
    this.submenuService.showRecordDetails("/users", this);  
  }

  save() {
    this.messageService.showLoading();
    this.usersService.saveUser(this.user).subscribe((data:UserModel) => {

      this.user = data;
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");

    });
  }

  delete() {
    alert("Delete form user edit component!");
  }
}
